import {
  OVERVIEW_ACTIVE,
  OVERVIEW_INACTIVE,
  FOLDER_ACTIVE,
  FOLDER_INACTIVE,
  REQUEST_ACTIVE,
  REQUEST_INACTIVE,
  PAYMENT_ACTIVE,
  PAYMENT_INACTIVE,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_INACTIVE,
  SETTING_ACTIVE,
  SETTING_INACTIVE,
  PANEL_ACTIVE,
  PANEL_INACTIVE,
} from "../../../../assets";

export const PoliceSidebarRoute = [
  {
    title: "Overview",
    activeIcon: OVERVIEW_ACTIVE,
    inactiveIcon: OVERVIEW_INACTIVE,
    path: "/police/overview",
  },
  {
    title: "Case Folders",
    activeIcon: FOLDER_ACTIVE,
    inactiveIcon: FOLDER_INACTIVE,
    path: "/police/case-folders",
  },
  {
    title: "Join request",
    activeIcon: REQUEST_ACTIVE,
    inactiveIcon: REQUEST_INACTIVE,
    path: "/police/request",
  },
  {
    title: "Teams",
    activeIcon: PANEL_ACTIVE,
    inactiveIcon: PANEL_INACTIVE,
    path: "/police/teams",
  },
  {
    title: "Payment history",
    activeIcon: PAYMENT_ACTIVE,
    inactiveIcon: PAYMENT_INACTIVE,
    path: "/police/payment-history",
  },
  {
    title: "Notification",
    activeIcon: NOTIFICATION_ACTIVE,
    inactiveIcon: NOTIFICATION_INACTIVE,
    path: "/police/notification",
  },
  {
    title: "Setting",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/police/setting",
  },
];
